<template>
    <div class="overlay">
        <div class="overlay_inner settings">
            <p class="note" v-translate>Platnosti služby pro odběratele</p>
            <date-picker
                    id="validityfrom"
                    attr-key="active_from"
                    :value="activeFrom"
                    date-format="d. m. yy"
                    @update-date="setDate">
                <translate>Platnost od</translate>
            </date-picker>
            <date-picker
                    id="validityto"
                    attr-key="active_to"
                    :value="activeTo"
                    date-format="d. m. yy"
                    @update-date="setDate">
                <translate>Platnost do</translate>
            </date-picker>
            <p class="buttons">
                <a
                        class="btn"
                                                @click.stop.prevent="emitSave"
                        v-translate>Uložit
                </a>
            </p>
            <a
                    class="btn btn_action btn_close"
                                        :title="'Zavřít' | translate"
                    @click.stop.prevent="emitClose"
                    v-translate>Zavřít
            </a>
        </div>
    </div>
</template>

<script>
	export default {
		name: "ServiceValidityPopup",
		props: {
			popupData: Object,
		},
		computed: {
			activeFrom() {
				return this.popupData.active_from
			},
			activeTo() {
				return this.popupData.active_to
			}
		},
		methods: {
			emitClose() {
				this.$emit('close')
			},
			emitSave() {
				this.$emit('save', {...this.popupData})
                this.emitClose()
			},
            setDate(data) {
                let newValue = data['date']
                if (newValue === '') {
                	newValue = null
                }
                this.popupData[data['attrKey']] = newValue
            }
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/servicesList/ServiceValidityPopup.vue